import 'vite/modulepreload-polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Roulette from '@/components/Roulette/EarlySummer';
// import Roulette from '../components/Roulette';
// import Roulette from '../components/Roulette/WooltariTable.jsx';

const rootElement = document.getElementById('campaign-roulette');
console.log(':::::::: campaign-roulette ::::::::', rootElement);
if (rootElement) {
  const customerId = rootElement.getAttribute('data-customer-id');
  const eventName = rootElement.getAttribute('data-event-name');
  const token = rootElement.getAttribute('data-token');
  const testToken = rootElement.getAttribute('data-test-token');
  const locale = rootElement.getAttribute('data-locale');

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <Roulette customerId={customerId} token={token} locale={locale} testToken={testToken} eventName={eventName} />
    </React.StrictMode>,
  );
}